import { MedicalChamber, MedicalChamberQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { OrderedPagination, paginations } from '@dreryk/command-query-ws-client';
import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { healthcarePracticeTranslationKeys } from '../../../translations';

import { HealthcarePracticeUpdateFormController } from './HealthcarePracticeUpdateForm.types';

type MedicalChamberSelectProps = Pick<HealthcarePracticeUpdateFormController, 'register'>;
const MEDICAL_CHAMBER_PAGINATION: OrderedPagination<
   MedicalChamber,
   MedicalChamber[]
> = paginations.all<MedicalChamber>().orderedBy('code', paginations.Direction.ASCENDING);

const medicalChamberSearchCreator = () => {
   return async (): CqrsQueryPerformResult<MedicalChamber[]> =>
      performCqrsQuerySearch<MedicalChamber>(() => new MedicalChamberQuery(), MEDICAL_CHAMBER_PAGINATION, {
         cacheTime: 'long',
      });
};

const medicalChamberLabelExtractor = (medicalChamber?: MedicalChamber): string =>
   `${medicalChamber!.code} - ${medicalChamber!.name}`;

const MedicalChamberSelectSearchCreator = (): JSX.Element => {
   return (
      <Select.SearchCreator<MedicalChamber> searchCreator={medicalChamberSearchCreator}>
         {({ items }) => (
            <Select.List<MedicalChamber> items={items} keyExtractor={'id'}>
               {(item) => (
                  <Select.Item
                     item={item}
                     label={createTranslatedText(`${item.code} - ${item.name}`)}
                     testId={item.id}
                     key={item.id}
                  />
               )}
            </Select.List>
         )}
      </Select.SearchCreator>
   );
};

export const MedicalChamberSelect = (props: MedicalChamberSelectProps): JSX.Element => {
   const controller = props.register('medicalChamber', { required: true });

   return (
      <Select<MedicalChamber>
         triggerLabelExtractor={medicalChamberLabelExtractor}
         testId={'medicalChamber'}
         label={healthcarePracticeTranslationKeys.medicalChamber}
         placeholder={healthcarePracticeTranslationKeys.chooseMedicalChamber}
         controller={controller}
      >
         <MedicalChamberSelectSearchCreator />
      </Select>
   );
};
